import { eur, monthsToLabel } from '../../lib/api';

export function AcqHero({ revealPrivate, conservative, optimistic, price, onScenarios }) {
  return (
    <header id="top" className="acq-hero">
      <div className="acq-container">
        <span className="acq-hero-badge">Planeamento · Plano executável do negócio</span>
        <h1 data-testid="hero-title">Plano executável para operar liofilização em Portugal.</h1>
        <p className="lead">
          Marca, presença digital, catálogo e modelo comercial já preparados. Este planeamento traduz a
          apresentação num plano de execução com cenários, sensibilidade e marcos a 90 dias.
        </p>
        <ul className="acq-hero-caveats">
          <li>Cenário de proprietário-operador.</li>
          <li>Projeções antes da remuneração do proprietário e de custos de financiamento.</li>
          <li>Fundo de maneio adicional apresentado separadamente.</li>
        </ul>
        {revealPrivate && (
          <div className="acq-hero-price" data-testid="hero-private-figures">
            <div className="figure">
              <small>Investimento inicial</small>
              {eur(price, 0)}
            </div>
            <div className="figure">
              <small>Payback · otimista</small>
              {monthsToLabel(optimistic?.payback_acquisition_months)}
            </div>
            <div className="figure">
              <small>Payback · pessimista</small>
              {monthsToLabel(conservative?.payback_acquisition_months)}
            </div>
          </div>
        )}
        <div className="acq-hero-actions">
          <button className="btn btn-primary" onClick={onScenarios} data-testid="cta-scenarios">
            Ver cenários financeiros
          </button>
        </div>
      </div>
    </header>
  );
}
